import axios from "axios";
import { store } from "../store/store";
import { logoutUser } from "../store/authSlice";
const baseURL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

const instance = axios.create({
  baseURL,
  timeout: 60000, // Increased to 60 seconds for CMS endpoints with large nested data
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
instance.interceptors.request.use(
  (config) => {
    try {
      const state = store.getState();
      const token = state.auth.token;
      
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch {
      // Store not available for token access
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    // Note: Successful responses (2xx) should not have 401/403 status codes
    // This block is kept for safety but shouldn't normally execute
    if (response.status === 401) {
      console.log('Axios - 401 response detected (invalid/expired token), logging out user');
      // Only dispatch if store is available
      try {
        store.dispatch(logoutUser());
      } catch {
        // Store not available for logout dispatch
      }
      if (typeof window !== 'undefined') {
        window.location.href = '/';
      }
      return Promise.reject({
        response: response,
        message: `Request failed with status code ${response.status}`,
        config: response.config
      });
    }

    return response;
  },
  (error) => {
    const status = error.response?.status;
    const errorData = error.response?.data;
    
    // Only logout on 401 (Unauthorized/Invalid Token)
    // Don't logout on 403 (Forbidden/Insufficient Permissions)
    if (status === 401) {
      console.log('Axios - 401 error detected (invalid/expired token), logging out user');
      // Only dispatch if store is available
      try {
        store.dispatch(logoutUser());
      } catch {
        // Store not available for logout dispatch
      }
      if (typeof window !== 'undefined') {
        window.location.href = '/';
      }
    } else if (status === 403) {
      // 403 means insufficient permissions - user is authenticated but not authorized
      // Don't logout, just let the error propagate to show permission denied message
      console.log('Axios - 403 error (insufficient permissions), not logging out user');
      console.log('Axios - Error message:', errorData?.error || errorData?.message);
    }

    return Promise.reject(error);
  }
);

export default instance;
